export default values => ({
  name: values && values.name ? values.name : '',
  paternalName: values && values.paternalName ? values.paternalName : '',
  maternalName: values && values.maternalName ? values.maternalName : '',
  phone: values.phone ? values.phone : '',
  email: values?.email ?? '',
  comission: values?.comission ?? 0,
});
